export enum ActivityWithoutIncomeSource {
    MINOR = '1',
    STUDENT = '2',
    UNEMPLOYEMENT_WITHOUT_BENEFIT = '3',
    HOUSEWIFE = '4',
    ACTIVITY_OF_COOWNER= '5',
    OTHERS= '6'
}
